"use strict";
/// <reference path="../../../../Trillium.UI/TypeScript/Models/General/API/UmbracoApiRequestResult.tsx"/>
/// <reference path="../../../../Trillium.UI/TypeScript/Models/Website/DocumentListApiModel.tsx"/>
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var DocumentLibraryService = /** @class */ (function () {
    function DocumentLibraryService() {
        this.baseEndpoint = "/umbraco/api/IPDDocumentLibraryAPI";
    }
    DocumentLibraryService.prototype.getsearchFiles = function (searchTerm, membershipNumber, recursive) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios_1.default.get(this.baseEndpoint + "/GetSearchFiles?searchTerm=" + searchTerm + "&recursive=" + recursive + "&membershipNumber=" + membershipNumber)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        err_1 = _a.sent();
                        return [2 /*return*/, { Success: false }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    DocumentLibraryService.prototype.getFolderWithRelatedItems = function (memberId, folderUrl) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios_1.default.get(this.baseEndpoint + '/GetFolderWithRelatedItemsByUrlAndId?folderUrl=' + folderUrl + '&memberId=' + memberId)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        err_2 = _a.sent();
                        return [2 /*return*/, { Success: false }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    DocumentLibraryService.prototype.deleteDocumentFile = function (fileUrls) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios_1.default.delete(this.baseEndpoint + '/deletefiles', {
                                data: {
                                    fileUrls: fileUrls
                                }
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        err_3 = _a.sent();
                        return [2 /*return*/, { Success: false }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    DocumentLibraryService.prototype.moveFile = function (fileUrl, newFolderUrl) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios_1.default.post(this.baseEndpoint + '/MoveFile', {
                                fileUrl: fileUrl,
                                newFolderUrl: newFolderUrl
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        err_4 = _a.sent();
                        return [2 /*return*/, { Success: false }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    DocumentLibraryService.prototype.moveFiles = function (fileUrls, newFolderUrl) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios_1.default.post(this.baseEndpoint + '/MoveFiles', {
                                fileUrls: fileUrls,
                                newFolderUrl: newFolderUrl
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        err_5 = _a.sent();
                        return [2 /*return*/, { Success: false }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    DocumentLibraryService.prototype.renameDocumentFile = function (fileUrl, fileName) {
        return __awaiter(this, void 0, void 0, function () {
            var fileType, splitFileName, newFileName, response, err_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        fileType = fileUrl.split('.').pop();
                        splitFileName = fileName.split('.');
                        splitFileName[splitFileName.length - 1] = fileType;
                        newFileName = splitFileName.join('.');
                        return [4 /*yield*/, axios_1.default.post(this.baseEndpoint + ("/renamefile?fileUrl=" + fileUrl + "&fileName=" + newFileName))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        err_6 = _a.sent();
                        return [2 /*return*/, { Success: false }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    DocumentLibraryService.prototype.uploadDocumentFile = function (fileData) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios_1.default.post(this.baseEndpoint + "/uploadfile", fileData)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        err_7 = _a.sent();
                        return [2 /*return*/, { Success: false }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    DocumentLibraryService.prototype.dowanloadFile = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var response, err_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, axios_1.default.get(this.baseEndpoint + ("/getdownload?fileUrl=" + url))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        err_8 = _a.sent();
                        return [2 /*return*/, { Success: false }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return DocumentLibraryService;
}());
exports.default = DocumentLibraryService;
